<template>
  <v-menu max-width="280" offset-y bottom nudge-bottom="10" left v-if="show">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="ma-2"
        v-bind="attrs"
        v-on="on"
        :color="
          logueado.disponibilidad
            ? estadoUsuario.find((el) => el.value === logueado.disponibilidad)
                .color
            : 'red'
        "
        icon
        title="Estado"
      >
        <v-icon>mdi-circle</v-icon>
      </v-btn>
    </template>
    <v-list>
      <div class="grey--text text--darken-3 px-4 pt-4">
        <v-radio-group v-model="estadoAsesor" column>
          <v-radio
            class="px-5 prueba"
            v-for="(item, i) in estadoUsuario"
            @click="updateEstado()"
            :key="i"
            :disabled="
              (item.value == 'Activo multiple' ||
                item.value == 'Activo ocupado') &&
              true
            "
            :label="item.title"
            :value="item.value"
          ></v-radio>
        </v-radio-group>
      </div>
    </v-list>
  </v-menu>
</template>
<script>
import { mapState } from "vuex";
import { db } from "../../firebase";

export default {
  data: () => ({
    estadoAsesor: "Fuera de su horario laboral",
  }),
  computed: {
    ...mapState(["estadoUsuario", "logueado"]),
    show() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.estadoAsesor = this.logueado.disponibilidad
        ? this.logueado.disponibilidad
        : "Fuera de su horario laboral";
      return this.logueado.cargo === "Abogado" ||
        this.logueado.cargo === "Investigador" ||
        this.logueado.cargo === "Abogado CAIT" ||
        this.logueado.cargo === "Call Center" ||
        this.logueado.cargo === "Dibujante" ||
        this.logueado.cargo === "Perito"
        ? true
        : false;
    },
  },
  methods: {
    async updateEstado() {
      const swal = await this.$swal({
        title: "Actualizar estado",
        text: `¿Esta seguro de actualizar?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Si, Actualizar !!",
        cancelButtonText: "No",
        cancelButtonColor: "#d33",
      });
      if (swal.isConfirmed) {
        try {
          db.collection("usuarios")
            .doc(this.logueado.id)
            .update({ disponibilidad: this.estadoAsesor })
            .then(() => {
              this.$store.dispatch("updatePerfilLogueado", {
                id: this.logueado.id,
              });
              this.$store.dispatch("trazabilidadEstadoUsuarios", {
                descripcion: "Estado actualizado por el usuario",
                estado: this.estadoAsesor,
                uidcaso: "",
                uidusuario: this.logueado.id,
              });
            });
        } catch (error) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.estadoAsesor = this.logueado.disponibilidad
            ? this.logueado.disponibilidad
            : "Fuera de su horario laboral";
          this.handleError(error);
        }
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.estadoAsesor = this.logueado.disponibilidad
          ? this.logueado.disponibilidad
          : "Fuera de su horario laboral";
      }
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>
